/* eslint-disable no-console */

import { isClient } from '../../utilities/isClient';

export const Logger = {
  error: (message: string, error?: Error) => {
    if (isClient() && window?.DD_LOGS) {
      window.DD_LOGS.getLogger?.('shared-header-footer')?.error(message, {}, error);
    }
    console.error({ message, error });
  },
  log: console.log,
};
